import { Pipe, PipeTransform } from '@angular/core';
import { NotificationGridItemObject } from '@it2go/types';
import { notificationTypeRule } from '@libs/types/src/notifications/enum/notification-type.enum';

@Pipe({
    name: 'parseParams',
    pure: true,
})
export class ParseParamsPipe implements PipeTransform {
    public transform(notification: NotificationGridItemObject): Record<string, any> | null {
        if (!notification.params) return null;

        try { return JSON.parse(notification.params); }
        catch { return null; }
    }
}

@Pipe({
    name: 'unreadCount',
})
export class UnreadCountPipe implements PipeTransform {

    public transform(value: any, ...args: any[]): any {
        return (value || []).reduce((acc: any, it: any) => acc + (it.isRead ? 0 : 1), 0);
    }
}

@Pipe({
    name: 'notificationTypeRule',
})
export class IsNotificationVisiblePipe implements PipeTransform {

    public transform(value: any, ...args: any[]): any {
        return notificationTypeRule(value);
    }

}
